export const HISTORY_CONSTS = {
    GET_HISTORY: "GET_HISTORY",
    CLEAR_HISTORY: 'CLEAR_HISTORY',
};
